import { Box, Typography } from '@mui/material';

import { Menu as MainMenu } from '../components/Menu'

const Main = () => {

    return (
        <>
            <MainMenu />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography>MAIN</Typography>
            </Box>
        </>
    )
}

export default Main;

